<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="基本信息" name="1">
      <info-item
        :title="['客户', '考察日期']"
        :data="[detail.name, detail.inspectDate]"
      ></info-item>
      <info-item
        :title="['考察性质', '考察类别']"
        :data="[detail.inspectQualityName, detail.inspectTypeName]"
      ></info-item>
      <info-item
        :title="['业务线', '考察目的']"
        :data="[detail.lines4BusiName, detail.inspectPurpose]"
      ></info-item>
      <info-item
        :title="['接待等级', '接待人']"
        :data="[detail.receptionLevelName, detail.receptionPeople]"
      ></info-item>
      <info-item
        :title="['讲解人', '去访人']"
        :data="[detail.explainer, detail.visitPeople]"
      ></info-item>
      <info-item :title="['考察申请人']" :data="[detail.inspectApplicant]"></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['创建人', '创建时间']"
        :data="[detail.createdName, formatTime(detail.gmtCreated)]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[detail.modifiedName, formatTime(detail.gmtModified)]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";
import { formatTimeFull } from "@/scripts/utils";

export default {
  props: {
    detail: Object,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
  methods: {
    formatTime(val) {
      return formatTimeFull(val);
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
